var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid-wrap"},[_c('div',{ref:"grid",staticClass:"grid-tbl-box",attrs:{"id":_vm.gridId}}),(_vm.options.enablePaging)?_c('div',{ref:"paging",staticClass:"pagingbox",attrs:{"id":_vm.pageId}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }